// packages
import { atom } from 'recoil';
// types
import { scrollWithPaginationType } from '../types';

export const scrollWithPaginationAtom = atom<scrollWithPaginationType>({
  key: 'ScrollWithPaginationAtom',
  default: { scrollY: 0, numberOfFetchNumber: 10 },
});
